import React, { useEffect } from "react";
import { LayoutMain } from "../../../../boxes/LayoutMain/LayoutMain";
import styles from "./styles.module.scss";
import { Header } from "./shared/Header";
import { Box } from "../../../../shared/Box/Box";
import { Filter } from "./shared/Filter";
import { Table } from "./shared/Table";
import { useDocuments } from "./hooks/useDocuments";
import { useMultiselectEntity } from "../../../../utilities/hooks/useMultiselectEntity";
import { useCurrentUserQuery } from "../../../../api/queries/useUserQuery";
import { PERMISSIONS } from "../../../../consts/api";
import { isDocumentSelectable } from "./utilities";
import { positionFooterCorrectly } from "../../../../Utils/services";

export function PatientDocuments() {
  var { documents, order, search, period, filter } = useDocuments();
  var { data: user } = useCurrentUserQuery();
  var permissions = user?.privileges || [];
  var canMutate = permissions.includes(PERMISSIONS.patientDocuments.mutate);
  var canView = permissions.includes(PERMISSIONS.patientDocuments.view);

  useEffect(() => {
    window.addEventListener("resize", positionFooterCorrectly);

    return () => {
      window.removeEventListener("resize", positionFooterCorrectly);
    };
  }, []);

  useEffect(() => {
    positionFooterCorrectly();
  }, [documents.isLoading, documents.isSoftLoading, documents.value.length]);

  var selectableDocumentIds = documents.value
    .filter((document) =>
      isDocumentSelectable(document, { canMutate, canView, permissions }),
    )
    .map((x) => x.id);

  var selection = useMultiselectEntity({
    allEntities: selectableDocumentIds,
    isSelectAllOnLoadMore: true,
  });

  return (
    <LayoutMain>
      <div className={styles.root}>
        <Header
          selection={selection}
          selectableDocumentIds={selectableDocumentIds}
          permissions={{
            canMutate,
            canView,
          }}
        />
        <Box className={styles.content}>
          <Filter
            search={search}
            filter={filter}
            period={period}
            docTypes={documents.docTypes}
          />
          <Table
            documents={documents}
            order={order}
            selection={selection}
            permissions={{
              canMutate,
              canView,
              values: permissions,
            }}
          />
        </Box>
      </div>
    </LayoutMain>
  );
}
